import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpscale = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-image-upscale-icon lucide-image-upscale",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M16 3h5v5" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 21h2a2 2 0 0 0 2-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 12v3" }),
		/* @__PURE__ */ _jsx("path", { d: "m21 3-5 5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 7V5a2 2 0 0 1 2-2" }),
		/* @__PURE__ */ _jsx("path", { d: "m5 21 4.144-4.144a1.21 1.21 0 0 1 1.712 0L13 19" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 3h3" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 11,
			width: 10,
			height: 10,
			rx: 1
		})
	]
});
export default SvgUpscale;
